import React, { useEffect, useState } from "react";
import styles from "./OverviewProduct.module.scss";
import emptyImg from "../../../../../../assets/images/empty-img.png";
import { CircleadditionIcon, CirclesubtractionIcon, CloseIcon2 } from "../../../../../../assets/icons/svgicons";
import { useDispatch, useSelector } from "react-redux";
import { formatPrice } from "../../../../../../utils/utils";
import { FORMIK_REGEX, STATUS_CODE } from "../../../../../../utils/constants";
import ErrorText from "../../../../Formik/ErrorText/ErrorText";
import { toFix } from "../../../../../../utils/utils";

const OverviewProduct = ({
  name,
  productData,
  baseURL,
  handleIncDec,
  handleRemoveFromCart,
  coinLists,
  getRangePrice,
  paymentMode,
}) => {




  const dispatch = useDispatch();
  const spotPremiumPrice = useSelector((state) => state?.users?.spotPremiumPrice);
  const spotPrice = useSelector((state) => state?.users?.spotPrice);
  const [quantityError, setQuantityError] = useState(null);
  const [isTyping, setIsTyping] = useState(false);

  const [liveQuantity, setLiveQuantity] = useState(Number(productData?.quantity || 0));

  const [inputValue, setInputValue] = useState(
    productData?.selection_mode === "VALUE"
      ? Number(productData.order_value || 0).toFixed(2)
      : Number(productData.quantity || 0).toFixed(
        coinLists.find(
          (coin) => coin.coin_symbol === productData.master_tokens_configuration?.name
        )?.quantity_decimal ?? 0
      ).replace(/\.?0+$/, "").replace(/\.$/, "")
  );

  const quantityDecimal = coinLists.find(
    (coin) => coin.coin_symbol === productData.master_tokens_configuration?.name
  )?.quantity_decimal ?? 0;

  const minOrderQty = coinLists.find(
    (coin) => coin.coin_symbol === productData.master_tokens_configuration?.name
  )?.min_order_qty ?? 1;

  const getMaxQuantityFromProductPrices = () => {
    const maxQuantities =
      productData?.product_price_chart?.map((price) => price?.max_quantity) || [];
    return maxQuantities.length > 0 ? Math.max(...maxQuantities) : 0;
  };

  const getUnitPrice = () => {
    const basePrice =
      productData?.token_id == 1
        ? spotPremiumPrice?.goldPrice || 0
        : spotPremiumPrice?.silverPrice || 0;
    return basePrice;
  };

  const getTotalPrice = (item) => {
    const basePrice =
      item?.token_id == 1
        ? spotPremiumPrice?.goldPrice || 0
        : spotPremiumPrice?.silverPrice || 0;
    const rangeFee = getRangePrice(
      Number(item?.quantity || 0),
      item?.product_price_chart,
      paymentMode
    );
    return formatPrice(Number(item?.quantity || 0) * (basePrice));
  };

  useEffect(() => {
    if (isTyping) return;

    const quantity = Number(productData?.quantity || 0);
    const maxQty = getMaxQuantityFromProductPrices();
    if (quantity > maxQty) {
      setQuantityError(`Quantity exceeds max range of ${maxQty}.`);
    } else if (quantity < minOrderQty) {
      setQuantityError(
        `Minimum order quantity is ${minOrderQty}. Please enter ${minOrderQty} or more.`
      );
    } else {
      setQuantityError(null);
    }

    setLiveQuantity(quantity);

    if (productData?.selection_mode !== "VALUE") {
      setInputValue(
        quantity.toFixed(quantityDecimal).replace(/\.?0+$/, "").replace(/\.$/, "")
      );
    }
  }, [
    productData?.quantity,
    productData?.selection_mode,
    productData?.order_value,
    minOrderQty,
    quantityDecimal,
    isTyping,
    spotPremiumPrice
  ]);

  const handleInputChange = (product, e) => {
    setIsTyping(true);
    const { value } = e.target;

    const maxDecimalPlaces = product.selection_mode === "VALUE" ? 2 : quantityDecimal;
    const regex = new RegExp(`^\\d*(\\.\\d{0,${maxDecimalPlaces}})?$`);

    if (value === "" || regex.test(value)) {
      setInputValue(value);

      if (value === "") {
        setQuantityError(null);
        setLiveQuantity(Number(product?.quantity || 0));
        return;
      }

      const numVal = Number(value);
      const maxQty = getMaxQuantityFromProductPrices();
      let finalQty = numVal;

      if (product.selection_mode === "VALUE") {
        const unitPrice = getUnitPrice(); // Define unitPrice here
        finalQty = unitPrice ? numVal / unitPrice : 0; // Calculate quantity based on USD value
      }

      setLiveQuantity(finalQty);

      if (!isNaN(numVal)) {
        if (finalQty < minOrderQty) {
          setQuantityError(
            `Minimum order quantity is ${minOrderQty}. Please enter ${minOrderQty} or more.`
          );
          return;
        }

        if (maxQty > 0 && finalQty > maxQty) {
          setQuantityError(`Quantity exceeds max range of ${maxQty}.`);
          return;
        }

        setQuantityError(null);
        handleIncDec(
          product,
          "",
          finalQty,
          maxDecimalPlaces,
          minOrderQty,
          product.selection_mode === "VALUE" ? numVal : null
        );
      }
    } else {
      setQuantityError(`Please enter a valid number (up to ${maxDecimalPlaces} decimal places).`);
    }
  };

  const handleBlur = (e) => {
    setIsTyping(false);
    const val = e.target.value.trim();

    if (val === "") {
      setQuantityError(null);
      const defaultValue = (minOrderQty * getUnitPrice()).toFixed(2);
      setInputValue(
        productData?.selection_mode === "VALUE"
          ? defaultValue
          : minOrderQty.toString()
      );
      handleIncDec(
        productData,
        "",
        minOrderQty,
        quantityDecimal,
        minOrderQty,
        productData?.selection_mode === "VALUE" ? Number(defaultValue) : null
      );
      setLiveQuantity(minOrderQty);
      return;
    }

    const numVal = Number(val);
    if (!isNaN(numVal)) {
      const maxQty = getMaxQuantityFromProductPrices();
      let finalQty;

      if (productData?.selection_mode === "VALUE") {
        const unitPrice = getUnitPrice(); // Define unitPrice here
        finalQty = unitPrice ? numVal / unitPrice : minOrderQty;

        if (finalQty > maxQty) {
          finalQty = maxQty;
          setQuantityError(`Quantity exceeds max range of ${maxQty}.`);
          setInputValue((maxQty * unitPrice).toFixed(2));
        } else if (finalQty < minOrderQty && numVal > 0) {
          finalQty = minOrderQty;
          setQuantityError(
            `Minimum order quantity is ${minOrderQty}. Please enter ${minOrderQty} or more.`
          );
          setInputValue((minOrderQty * unitPrice).toFixed(2));
        } else {
          setQuantityError(null);
          setInputValue(numVal.toFixed(2)); // Keep user-entered value
        }
      } else {
        finalQty = numVal;

        if (numVal > maxQty) {
          finalQty = maxQty;
          setQuantityError(`Quantity exceeds max range of ${maxQty}.`);
          setInputValue(maxQty.toFixed(quantityDecimal));
        } else if (numVal < minOrderQty) {
          finalQty = minOrderQty;
          setQuantityError(
            `Minimum order quantity is ${minOrderQty}. Please enter ${minOrderQty} or more.`
          );
          setInputValue(minOrderQty.toFixed(quantityDecimal));
        } else {
          setQuantityError(null);
          setInputValue(numVal.toFixed(quantityDecimal));
        }
      }

      setLiveQuantity(finalQty);
      handleIncDec(
        productData,
        "",
        finalQty,
        quantityDecimal,
        minOrderQty,
        productData?.selection_mode === "VALUE" ? numVal : null
      );
    } else {
      setQuantityError("Invalid format.");
      const defaultValue = (minOrderQty * getUnitPrice()).toFixed(2);
      setInputValue(
        productData?.selection_mode === "VALUE"
          ? defaultValue
          : minOrderQty.toString()
      );
      handleIncDec(
        productData,
        "",
        minOrderQty,
        quantityDecimal,
        minOrderQty,
        productData?.selection_mode === "VALUE" ? Number(defaultValue) : null
      );
      setLiveQuantity(minOrderQty);
    }
  };

  return (
    <div className={styles.product}>
      <img
        src={
          (productData?.product_images?.length > 0 &&
            baseURL +
            `${productData?.product_id}/${productData?.product_images[0]?.image}`) ||
          emptyImg
        }
        alt="product"
      />
      <div className={styles.product_details}>
        <h3>
          {name || "Nothing to see here"}{" "}
          <button onClick={() => handleRemoveFromCart(productData)}>
            <CloseIcon2 />
          </button>
        </h3>
        <p>
          Price: As low as $
          {formatPrice(
            Number(
              productData?.token_id === 1
                ? spotPrice.goldPrice
                : spotPrice.silverPrice
            )
          )}
        </p>
        <div className={styles.qty}>
          <div className={styles.qty_left}>
            <button
              onClick={() => {
                if (productData?.selection_mode === "VALUE") {
                  const currentValue = Number(inputValue || 0);
                  const unitPrice = getUnitPrice();
                  const currentQty = unitPrice ? currentValue / unitPrice : 0;
                  const newQty = Math.max(currentQty - minOrderQty, minOrderQty);
                  const newOrderValue = newQty * unitPrice;
                  setLiveQuantity(newQty);
                  setInputValue(newOrderValue.toFixed(2));
                  handleIncDec(
                    productData,
                    "",
                    newQty,
                    quantityDecimal,
                    minOrderQty,
                    newOrderValue
                  );
                } else {
                  Number(productData.quantity || 0) > minOrderQty &&
                    handleIncDec(
                      productData,
                      "-",
                      undefined,
                      quantityDecimal,
                      minOrderQty
                    );
                }
              }}
              disabled={
                productData?.selection_mode === "VALUE"
                  ? Number(liveQuantity || 0) <= minOrderQty
                  : Number(productData.quantity || 0) <= minOrderQty
              }
            >
              <CirclesubtractionIcon />
            </button>
            <input
              value={inputValue}
              onChange={(e) => handleInputChange(productData, e)}
              maxLength={10}
              placeholder={
                productData?.selection_mode === "VALUE"
                  ? "Enter Value ($)"
                  : ""
              }
              onBlur={handleBlur}
            />
            <button
              onClick={() => {
                if (productData?.selection_mode === "VALUE") {
                  const currentValue = Number(inputValue || 0);
                  const unitPrice = getUnitPrice();
                  const currentQty = unitPrice ? currentValue / unitPrice : 0;
                  const newQty = currentQty + minOrderQty;
                  const newOrderValue = newQty * unitPrice;
                  setLiveQuantity(newQty);
                  setInputValue(newOrderValue.toFixed(2));
                  handleIncDec(
                    productData,
                    "",
                    newQty,
                    quantityDecimal,
                    minOrderQty,
                    newOrderValue
                  );
                } else {
                  handleIncDec(
                    productData,
                    "+",
                    undefined,
                    quantityDecimal,
                    minOrderQty
                  );
                }
              }}
              disabled={
                productData?.selection_mode === "VALUE"
                  ? Number(liveQuantity || 0) >= getMaxQuantityFromProductPrices()
                  : Number(productData.quantity || 0) >=
                  getMaxQuantityFromProductPrices()
              }
            >
              <CircleadditionIcon />
            </button>
            {/* <p>
              {productData?.selection_mode === "VALUE"
                ? `$${(liveQuantity * getUnitPrice()).toFixed(2)}`
                : toFix(Number(liveQuantity), quantityDecimal)}
            </p> */}
          </div>
          <h5
            className={
              (productData?.quantity || 0) * (productData?.price || 0) === 0
                ? styles.inactive
                : ""
            }
          >
            {productData?.selection_mode === "VALUE"
              ? `Qty: ${toFix(Number(liveQuantity), quantityDecimal)}`
              : `Total: $${(liveQuantity * getUnitPrice()).toFixed(2)}`}
          </h5>
        </div>
        {quantityError && <ErrorText>{quantityError}</ErrorText>}
      </div>
    </div>
  );
};

OverviewProduct.defaultProps = {
  itemsInCart: 0,
  price: 0,
};

export default OverviewProduct;